export const publicGraphqlQueries = {
	queryFetchSampleToListen: `
		query fetchSampleToListen($id: String!) {
			sampleById(_id: $id) {
				_id
				name
				description
				image
				tracks {
					trackId
					start
					end
				}
				trackObjects {
					_id
					title
					artist
					optimizedMono {
						duration
					}
					optimizedStereo {
						duration
					}
					artwork
					comment
				}
			}
		}
	`,

	mutationCreateSampleReview: `
		mutation createSampleReview($email: String!, $tracks: [SampleReviewTracksInput], $sampleId: String!, $comment: String, $name: String!) {
			sampleReviewCreate(
				email: $email,
				tracks: $tracks,
				sampleId: $sampleId,
				comment: $comment,
				name: $name
			) {
				recordId
			}
		}
	`
}
